const renderedPhotosTemplate = require('templates/widgets/personalized-grid/photos.hbs');
const renderedIndexTemplate = require('templates/widgets/personalized-grid/index.hbs');

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

const DEFAULTS = { rows: 2, cols: 5 };

L2H.PersonalizedGridWidget = class PersonalizedGridWidget extends L2H.Widget {
  constructor($container, photosURL, options) {
    super(...arguments);
    this.$container = $container;
    this.photosURL = photosURL;
    this.photoMatrix = [];
    this.rows = (this.cols = null);

    this.rows = options.rows || DEFAULTS.rows;
    this.cols = options.cols || DEFAULTS.cols;

    this.brandPhotoURL = options.bpURL;
    this.brandPhotoClickURL = options.bpClickURL;

    this.renderIndex();

    this.modalView = new L2H.PhotoModalView(this.$container, 'grid-widget', null, options);

    this.fetchPhotos();
  }

  fetchPhotos() {
    const self = this;
    return $.ajax({
      url: this.photosURL,
      data: {per: this.cols*this.rows},
      dataType: "jsonp"
    }).done(function(data) {
      self.modalView.setPhotos(data.photos);
      self.createPhotoMatrix(data.photos);

      self.renderPhotos();

      let brokenPhotoChecker = new L2H.BrokenPhotoCheck();
      brokenPhotoChecker.call(data.photos);
    });
  }

  createPhotoMatrix(photos) {
    let j = -1;

    this.photoMatrix = [];

    const result = [];

    for (let i = 1; i < photos.length; i++) {
      if (((i % this.cols) === 0) || (i === 1)) {
        j++;
        this.photoMatrix[j] = [];
      }
      this.photoMatrix[j].push(photos[i-1]);
    }
  }

  filenameFromURL(url) {
    if (url) {
      const m = url.toString().match(/.*\/(.+?)\./);
      if (m && m.length > 1) {
        return m[1];
      }
    }
    return "";
  }


  renderPhotos() {
    const renderedPhotos = renderedPhotosTemplate({photoMatrix: this.photoMatrix,
                                                   brandPhotoURL: this.brandPhotoURL,
                                                   brandPhotoTitle: this.filenameFromURL(this.brandPhotoURL),
                                                   brandPhotoClickURL: this.brandPhotoClickURL,
                                                   preferences: this.preferences});

    return this.$container.find('.l2h-photos').append(renderedPhotos);
  }

  renderIndex() {
    const renderedIndex = renderedIndexTemplate({rows: this.rows, cols: this.cols, preferences: this.preferences});
    return this.$container.html(renderedIndex);
  }
}
